import type { FirebaseRepository } from './FirebaseRepository'
import type { MobxDocument } from '../types'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import { empty } from '../firestore/UserProfileFavoriteSlideDeck/schema'
import type { FirestoreUserProfileFavoriteSlideDeck } from '../firestore/UserProfileFavoriteSlideDeck'

export class UserProfileFavoriteSlideDeck extends ObservableModelWithDecorators<FirestoreUserProfileFavoriteSlideDeck> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreUserProfileFavoriteSlideDeck>
  ) {
    super(repository, doc)
  }
}
